import React from "react";
import PropTypes from "prop-types";
import {
  ZYGOSITY_LABELS,
  MITO,
  SOMATIC,
  HOMOZYGOUS,
  HOMOZYGOUS_PHASED,
  HETEROZYGOUS_1_PHASED,
  HETEROZYGOUS_2_PHASED,
  HETEROZYGOUS_1,
} from "../../constants/zygosity";
import HalfCircle from "../../../../../../assets/images/svg/half-circle.svg";
import Disk from "../../../../../../assets/images/svg/disk.svg";
import DotCircle from "../../../../../../assets/images/svg/dot-circle.svg";

function Zygosity({ zygosity }) {
  const label = ZYGOSITY_LABELS[zygosity];
  const isHomo = zygosity === HOMOZYGOUS || zygosity === HOMOZYGOUS_PHASED;
  const isHeteroUnphased = zygosity === HETEROZYGOUS_1;
  const isHeteroPhased1 = zygosity === HETEROZYGOUS_1_PHASED;
  const isHeteroPhased2 = zygosity === HETEROZYGOUS_2_PHASED;
  const isSomatic = zygosity === SOMATIC;
  const isMito = zygosity === MITO;

  if (!label) {
    return <span className="tw-italic tw-opacity-60">-</span>;
  }

  if (isSomatic) {
    return (
      <DotCircle
        data-tooltip={`Zygosity: ${label}`}
        data-tooltip-class="genome-browser-small-tooltip"
        className="tw-w-3 tw-fill-current tw-inline-block"
      />
    );
  }

  if (isMito) {
    return (
      <DotCircle
        data-tooltip={`Zygosity: ${label}`}
        data-tooltip-class="genome-browser-small-tooltip"
        className="tw-w-3 tw-fill-current tw-inline-block"
      />
    );
  }

  if (isHomo) {
    return (
      <Disk
        data-tooltip={`Zygosity: ${label}`}
        data-tooltip-class="genome-browser-small-tooltip"
        className="tw-w-3 tw-fill-current tw-inline-block"
      />
    );
  }

  if (isHeteroUnphased) {
    return (
      <HalfCircle
        data-tooltip={`Zygosity: ${label}`}
        data-tooltip-class="genome-browser-small-tooltip"
        className="tw-w-3 tw-fill-current tw-inline-block tw-transform tw-rotate-45"
      />
    );
  }

  if (isHeteroPhased1) {
    return (
      <HalfCircle
        data-tooltip={`Zygosity: ${label}`}
        data-tooltip-class="genome-browser-small-tooltip"
        className="tw-w-3 tw-fill-current tw-inline-block"
      />
    );
  }

  if (isHeteroPhased2) {
    return (
      <HalfCircle
        data-tooltip={`Zygosity: ${label}`}
        data-tooltip-class="genome-browser-small-tooltip"
        className="tw-w-3 tw-fill-current tw-inline-block tw-transform tw-rotate-180"
      />
    );
  }

  return <span className="tw-italic tw-opacity-60">-</span>;
}

Zygosity.propTypes = {
  zygosity: PropTypes.number.isRequired,
};

Zygosity.defaultProps = {};

export default Zygosity;
